import styles from "../../pages/Community/CreateCommunityPage.module.css";
import placeholderImage from "../../assets/images/image-upload-placeholder.png";

const CommunityImageUpload = ({
  bannerPreview,
  iconPreview,
  handleBannerUpload,
  handleIconUpload,
  isSubmitting,
}) => {
  return (
    <div className={styles.imageSectionWrapper}>
      {bannerPreview && (
        <div className={styles.featuredImageBox}>
          <img
            src={bannerPreview}
            alt="Banner Preview"
            className={styles.featuredImageBox}
          />
          <div className={styles.iconUploadContainer}>
            <img
              src={iconPreview || placeholderImage}
              alt="Icon Preview"
              className={styles.iconPlaceholder}
            />
            <div className={styles.uploadLinks}>
              <label className={styles.uploadLink}>
                <span className={styles.plusIcon}>+</span> Choose Featured Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleBannerUpload}
                  disabled={isSubmitting}
                />
              </label>
              <label className={styles.uploadLink}>
                <span className={styles.plusIcon}>+</span> Choose icon
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleIconUpload}
                  disabled={isSubmitting}
                />
              </label>
            </div>
          </div>
        </div>
      )}
      {!bannerPreview && (
        <div className={styles.featuredImageBox}>
          <div className={styles.iconUploadContainer}>
            <img
              src={iconPreview || placeholderImage}
              alt="Icon Preview"
              className={styles.iconPlaceholder}
            />
            <div className={styles.uploadLinks}>
              <label className={styles.uploadLink}>
                <span className={styles.plusIcon}>+</span> Choose Featured Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleBannerUpload}
                  disabled={isSubmitting}
                />
              </label>
              <label className={styles.uploadLink}>
                <span className={styles.plusIcon}>+</span> Choose icon
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleIconUpload}
                  disabled={isSubmitting}
                />
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommunityImageUpload;
